import React from "react";
import { IGame, IGameApplication } from "@/redux/games/types";
import styles from "./CreateGameContent.module.scss";
import UserIcon from "@/assets/icons/login.svg";
import StonksIcon from "@/assets/icons/stonks.svg";
import PhoneIcon from "@/assets/icons/phoneBlack.svg";

interface CreateGameContentProps {
  game: IGame;
}

const formatPhone = (phone: string) => {
  const cleaned = phone.replace(/[^0-9]/g, "");
  if (cleaned.length === 11) {
    return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9, 11)}`;
  }
  return phone;
};

const copyPhoneToClipboard = async (phone: string) => {
  try {
    await navigator.clipboard.writeText(phone);
    // TODO: Показать уведомление об успешном копировании
  } catch (error) {
    console.error("Failed to copy phone:", error);
  }
};

export const CreateGameContent: React.FC<CreateGameContentProps> = ({ game }) => {
  const applications = game.applications || [];

  if (applications.length === 0) {
    return (
      <div className={styles.empty}>
        <p>Заявок пока нет</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Заявки ({applications.length})</h3>
      </div>

      <div className={styles.list}>
        {applications.map((application: IGameApplication) => (
          <div key={application.id} className={styles.item}>
            <div className={styles.itemRow}>
              <img src={UserIcon} alt="user" className={styles.icon} />
              <span className={styles.text}>{application.name}</span>
            </div>
            <div className={styles.itemRow}>
              <img src={StonksIcon} alt="stonks" className={styles.icon} />
              <span className={styles.text}>{application.level}</span>
            </div>
            <div className={styles.itemRow}>
              <img src={PhoneIcon} alt="phone" className={styles.icon} />
              <button
                className={styles.phoneButton}
                onClick={() => copyPhoneToClipboard(application.phone)}
              >
                {formatPhone(application.phone)}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
